export default function (rootEl) {
    const allListItem = rootEl.querySelectorAll('.js-content-list-item');
    const allOptions = rootEl.querySelectorAll('.js-content-filter-option');
    let activeOptions = [];

    function intersection(a, b)
    {
        const setA = new Set(a);
        return b.filter(value => setA.has(value));
    }

    allOptions.forEach(filterOption => {
        filterOption.addEventListener('click', function(e) {
            const tagValue = JSON.parse(filterOption.dataset.tag);
            if (tagValue === 'All')
            {
                activeOptions = [];
                allOptions.forEach(item => item.classList.remove('is-on'));
                allListItem.forEach(item => item.classList.remove('hidden'));
                filterOption.classList.toggle('is-on');
            }
            else
            {
                allOptions.forEach(item => { if (item.dataset.tag.includes("All")) item.classList.remove('is-on') })
                const hasBeenOn = filterOption.classList.contains('is-on');

                if (hasBeenOn)
                {
                    activeOptions = activeOptions.filter(item => item !== tagValue);
                }
                else
                {
                    activeOptions = [...activeOptions, tagValue];
                }

                filterOption.classList.toggle('is-on');

                if (!activeOptions.length)
                {
                    allListItem.forEach(item => item.classList.remove('hidden'));
                    allOptions.forEach(item => { if (item.dataset.tag.includes("All")) item.classList.add('is-on') })
                    return;
                }

                allListItem.forEach(item => item.classList.add('hidden'));

                allListItem.forEach(listItem => {
                    const listItemTags = listItem.dataset.tags !== '' ? JSON.parse(listItem.dataset.tags) : [];
                    if (intersection(activeOptions, listItemTags).length)
                    {
                        listItem.classList.remove('hidden');
                    }
                })
            }
        })
    })
};
